module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f0751f_banner_800x600.a85e72a0.png";